import {config} from 'config/env';
import {GET_CHECKOUT_BY_ID} from 'services/checkout/constants/queries';
import {Address, BasketItemInput, Checkout, DirectCheckoutCreateInput, IDefaultCheckoutResponse} from 'types';
import {createCheckoutPayload, post} from 'utils';
import {checkoutApolloClientWithToken} from 'utils/apollo';

import {CREATE_CHECKOUT_FOR_INSTALLMENT, CREATE_CHECKOUT_V2} from './constants/mutations';

export async function getCheckoutById(checkoutId: string, idToken?: string): Promise<{data: IDefaultCheckoutResponse}> {
  const checkoutApolloClient = checkoutApolloClientWithToken(idToken);
  const response = await checkoutApolloClient.query<IDefaultCheckoutResponse>({
    query: GET_CHECKOUT_BY_ID,
    variables: {
      checkoutId
    }
  });
  return response;
}

export async function getCheckoutIdV2(
  idToken: string,
  zipCode: string | undefined,
  subDistrict: string,
  shippingAddress?: Address,
  locale?: string,
  isGoingToSAC?: boolean,
  allowCustomAttributes?: boolean,
  basketSize?: number,
  basketValue?: number,
  accessTradeClickId?: string,
  pricezaClickId?: string,
  isExpress?: boolean,
  appVersion?: string,
  deviceOS?: string,
  makroMemberId?: string,
  trueId?: string
): Promise<any> {
  const checkoutApolloClient = checkoutApolloClientWithToken(idToken);
  const checkoutPayload = createCheckoutPayload(
    'v2',
    undefined,
    zipCode,
    subDistrict,
    shippingAddress,
    locale,
    isGoingToSAC,
    allowCustomAttributes,
    basketSize,
    basketValue,
    accessTradeClickId,
    pricezaClickId,
    isExpress,
    appVersion,
    deviceOS,
    makroMemberId,
    trueId
  );
  try {
    const res = await checkoutApolloClient.mutate({
      mutation: CREATE_CHECKOUT_V2,
      variables: {
        input: checkoutPayload
      }
    });

    if (res?.errors?.length || !res?.data?.createCheckoutV2.id) {
      throw new Error(res?.errors?.[0]?.message);
    }

    return {checkoutId: res?.data?.createCheckoutV2?.id, warning: res?.data?.errorMessage};
  } catch (error: any) {
    throw new Error(error.message);
  }
}

export async function createPartialCheckout(
  input: DirectCheckoutCreateInput,
  basketItem: BasketItemInput[],
  idToken: string
): Promise<Checkout> {
  const checkoutApolloClient = checkoutApolloClientWithToken(idToken);
  const {data, errors} = await checkoutApolloClient.mutate<{checkout: Checkout}>({
    mutation: CREATE_CHECKOUT_FOR_INSTALLMENT,
    variables: {
      input,
      basketItem
    }
  });

  if (data) {
    return data?.checkout;
  }

  throw errors;
}

export async function createPartialCheckoutV3(
  input: DirectCheckoutCreateInput,
  basketItem: BasketItemInput[],
  idToken: string
): Promise<Checkout> {
  try {
    const endPointURL = `${config.CHECKOUT_API_BASE_URL}/checkout/mpro/api/v3`;
    const response: Checkout = await post(endPointURL, {...input, basketItem}, true, false, true, true, idToken, true);
    return response;
  } catch (error: any) {
    throw new Error(error.message);
  }
}
